import script from "./Page2.vue?vue&type=script&setup=true&lang=js"
export * from "./Page2.vue?vue&type=script&setup=true&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=69aa4e18&lang=less"

const __exports__ = script;

export default __exports__